import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

/**
 * Combines the static initialState, and route paramMap and resolves them to an object
 */
@Injectable({ providedIn: 'root' })
export class ParamMapResolver
    
{
    resolve(route: ActivatedRouteSnapshot) {
        const paramMap = route.paramMap.keys.reduce((acc, key) => {
            acc[key] = isNaN(+route.paramMap.get(key))
                ? route.paramMap.get(key)
                : +route.paramMap.get(key);
            return acc;
        }, {});

        return {
            ...route.data.initialState,
            ...paramMap
        };
    }
}

/**
 * Combines the static initialState, route paramMap and queryParamMap and resolves them to an object
 */
@Injectable({ providedIn: 'root' })
export class FullParamMapResolver
    
{
    resolve(route: ActivatedRouteSnapshot) {
        const paramMap = route.paramMap.keys.reduce((acc, key) => {
            acc[key] = isNaN(+route.paramMap.get(key))
                ? route.paramMap.get(key)
                : +route.paramMap.get(key);
            return acc;
        }, {});
        const queryParamMap = route.queryParamMap.keys.reduce((acc, key) => {
            acc[key] = isNaN(+route.queryParamMap.get(key))
                ? route.queryParamMap.get(key)
                : +route.queryParamMap.get(key);
            return acc;
        }, {});
        return {
            ...route.data.initialState,
            ...paramMap,
            ...queryParamMap
        };
    }
}
